import ApiConstants from "./apiConstants";
import AppConstants from "./appConstants";

export default {
  ...ApiConstants,
  ...AppConstants,
};
